import { Component, OnInit, Input, ViewChild, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FilesService } from 'app/services/files.service';
import { File } from 'app/models/file';
import { FileType } from 'app/models/file-type.enum';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-cover-tile',
  templateUrl: './cover-tile.component.html',
  styleUrls: ['./cover-tile.component.scss'],
  providers: [FilesService]
})
export class CoverTileComponent implements OnInit, OnChanges {
  @ViewChild('coverImage') coverImage: any;
  @ViewChild('coverForm') coverForm: NgForm;
  @Input() coverPage: File;
  @Output() save: EventEmitter<File> = new EventEmitter();

  description: string;

  constructor(private fileService: FilesService) {
  }

  ngOnInit() {
    this.showImage();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.coverPage) {
      this.showImage();
    }
  }

  onSave() {
    if (this.coverPage && this.coverForm.dirty) {
      this.save.emit(this.coverPage);
    }
  }

  attachImage(event) {
    const doc = event.dragData;
    if (doc.contentType === FileType.Img &&
        (!this.coverPage || doc.id !== this.coverPage.documentId)) {
      this.coverPage.documentId = doc.id;
      this.coverPage.contentType = doc.contentType;
      this.coverPage.displayName = doc.displayName;
      this.coverPage.name = doc.name;
      this.onSave();
      this.showImage();
    }
  }

  showImage() {
    if (this.coverPage.documentId) {
      this.fileService
        .download(this.coverPage.documentId)
        .subscribe((result) => {
          this.coverImage.nativeElement.src = URL.createObjectURL(result.content);
        });
    } else {
      this.coverImage.nativeElement.src = '';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/cover-tile/cover-tile.component.ts